import axios from 'axios';

const list = params => axios.get('/configuracoes-aprovacoes-compras', {
  params,
});

const get = id => axios.get(`/configuracoes-aprovacoes-compras/${id}`);

const create = data => axios.post('/configuracoes-aprovacoes-compras', data);

const update = (id, data) => axios.put(`/configuracoes-aprovacoes-compras/${id}`, data);

export default {
  get,
  list,
  create,
  update,
};
